export default __webpack_public_path__ + "static/media/character_win_2.11560cb4.mp3";